import { FETCH_METHODS, SearchConfig } from "./api.model";
import { DataTableSchema, DefaultTableSchema } from "./dynamic-data-table.model";
import { PaymentTypeDropdown, StatusDropdown, StartDateDate, CompletionDateDate, FACILITYText, CreditDropdown, peopleattendedText, SpinIdNumber, FirstNameText, LastNameText, DealerNumber, FieldNames, defaultManageExceptionPaymentButtons, CourseNameCodeDropdown } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

const FormFieldArray: FormFieldConfig[] = structuredClone([PaymentTypeDropdown, DealerNumber, CourseNameCodeDropdown, StatusDropdown, StartDateDate, CompletionDateDate, FACILITYText, CreditDropdown, peopleattendedText, SpinIdNumber, 
    {...structuredClone(FirstNameText), pattern: String.raw`^[a-zA-Z\s-]+$`}, {...structuredClone(LastNameText), pattern: String.raw`^[a-zA-Z\s-]+$`}])
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultManageExceptionPaymentButtons);
export const ExcludedRequiredFieldsList: Array<string> = [FieldNames.PeopleAttended, FieldNames.SpinId, FieldNames.FirstName, FieldNames.LastName, FieldNames.CompletionDate];
export const searchConfig: SearchConfig = {
    path: 'exceptionPaymentAdd',
    method: FETCH_METHODS['Post'],
    body:
    {
        "paymentType": "",
        "credit": "",
        "courseNameCode": "",
        "completionDate": "",
        "startDate": "",
        "firstName": "",
        "lastName": "",
        "spinId": "",
        "status": "",
        "dealerCode": "",
        "facility": "",
        "addedBy": "",
        "addedByUser": "",
        "peopleAttended": ""
    }
}

export const searchGetConfig: SearchConfig = {
    method: FETCH_METHODS['Get'],
    path: 'exceptionPayment',
}

export const ManageExceptionpaymentReportTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: 'SPIN ID', fieldKey: 'spinID', sticky: true },
        { label: 'DEALER', fieldKey: 'dealer', sticky: true },
        { label: 'PAYMENT TYPE', fieldKey: 'paymentType' },
        { label: 'COURSE', fieldKey: 'course', isNotCamelCase: true },
        { label: 'STATUS', fieldKey: 'status', },
        { label: 'START DATE', fieldKey: 'startDate' },
        { label: 'COMPLETION DATE', fieldKey: 'completionDate', },
        { label: 'FACILITY', fieldKey: 'facility', },
        { label: 'NAME', fieldKey: 'name', },
        { label: 'AMOUNT', fieldKey: 'amount', },
    ],
    isSearchRequired: true,
    isPaginationRequired: true,
    exportConfig: {
        fileName: 'Manage_Exception_Payment_Report',
        exportMessage: "Manage Exception Payment Data",
        isCamelCase:['facility','name'],
           schema:{
            spinID: "SPIN ID",
            dealer: "DEALER",
            paymentType: "PAYMENT TYPE",
            course: "COURSE",
            status: "STATUS",
            startDate: "START DATE",
            completionDate:"COMPLETION DATE",
            facility: "FACILITY",
            name: "NAME",
            amount: "AMOUNT",
        }
    }
}
export const ManageExceptionFilterTitle = "Create Exception Payment";
export const ManageExceptionpaymentReportFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: searchConfig,
    title: ManageExceptionFilterTitle,
    resetAfterSubmit: true
}

export const ManageExceptionpaymentReportProps: Props = {
    isSearchVisible: true,
    isTabStretch: true
}